<template>
  <div>
    <Bio :extra="extra" :lite="true" />

    <QBtn
      v-if="canCancelShifts"
      class="full-width"
      outline
      :label="$t('ETAB.PAGES.EXTRA.@CANCEL_FUTURE_SHIFTS')"
      icon="close"
      color="negative"
      @click="$emit('cancelShifts', { extra })"
    />

    <Shifts :extra="extra" @open-recruitment-recap="$emit('openRecruitmentRecap')" />
  </div>
</template>

<script>
  import { ExtraModel } from "@core/models";

  import Bio from "@etab/components/extra/Bio.component.vue";
  import Shifts from "@etab/components/extra/Shifts.component.vue";

  export default {
    components: {
      Bio,
      Shifts,
    },
    props: {
      extra: {
        type: Object,
        default: () => new ExtraModel(),
      },
      canCancelShifts: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["cancelShifts", "openRecruitmentRecap"],
  };
</script>
